import Splide from "@splidejs/splide";

window.addEventListener('load', () => {
    const image_sliders = document.querySelectorAll<HTMLElement>(".image-slider-splide");
    image_sliders.forEach(sliderElement => {
        const slider = new Splide(sliderElement, {
            perPage: 3,
            focus: 0,
            type: 'loop',
            gap: "40px",
            breakpoints: {
                991: {
                    perPage: 2,
                    gap: "40px",
                },
                575: {
                    perPage: 1,
                    gap: "50px",
                },
            }
        });
        slider.mount();
    });
});
